import { render, staticRenderFns } from "./PublicLogin.vue?vue&type=template&id=01c4a78c&"
import script from "./PublicLogin.vue?vue&type=script&lang=js&"
export * from "./PublicLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c4a78c')) {
      api.createRecord('01c4a78c', component.options)
    } else {
      api.reload('01c4a78c', component.options)
    }
    module.hot.accept("./PublicLogin.vue?vue&type=template&id=01c4a78c&", function () {
      api.rerender('01c4a78c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PublicLogin.vue"
export default component.exports